import React from 'react'

function StartupCardTag({ title }) {
    return (
        <div className="px-2 mt-2 mr-2 text-white rounded-md bg-btn-secondary">
            <span className="text-xs leading-6 font-open-sans-regular">
                {title}
            </span>
        </div>
    )
}

export default StartupCardTag
